import { StateService } from './state.service';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { TranslationType } from '../models/translation-type';
import { environment } from '../../environments/environment';


@Injectable()
export class SettingsService {

  constructor(private api: ApiService,
              private stateService: StateService) { }

  getTranslationTypes() {

    const url = environment.apiUrl + '/translation/types';

    return this.api.get(url).then((data)=>{
      return new Promise((resolve, reject) => {
        try
        {
          resolve(data['ProcessOutcome']['TranslationTypes']);
        }
        catch (e)
        {
          reject(e);
        }
      })
    });
  }  

  getTranslationOptions(type: string) {

    const url = environment.apiUrl + '/translation/types/' + type;

    return this.api.get(url).then((data)=>{
      return new Promise((resolve, reject) => {
        try
        {
          resolve(data['ProcessOutcome']['TranslationOptions']);
        }
        catch (e)
        {
          reject(e);
        }
      })
    });
  }
  
  getTranslationValues(type: string) {

    const url = environment.apiUrl + '/translation/types/' + type + '/values';

    return this.api.get(url).then((data)=>{
      return new Promise((resolve, reject) => {
        try
        {
          resolve(data['ProcessOutcome']['TranslationValues']);
        }
        catch (e)
        {
          reject(e);
        }
      })
    });
  }

  setTranslationValue(type: string, code: string, translation: string) {

    const url = environment.apiUrl + '/translation/types/' + type + '/values';

    const body = {
      code: code,
      translation: translation
    }

    return this.api.post(url, body).then((data)=>{
      return new Promise((resolve, reject) => {
        try
        {
          resolve(data['ProcessOutcome']);
        }
        catch (e)
        {
          reject(e);
        }
      })
    });

  }
}
